import {
  ROUTE_PATH_LIST,
  ROUTE_PATH_LIST_SETTINGS,
  ROUTE_UI_SECTION_NAME,
} from '../../../constants/route'
import { getWebappLinkPrefix } from '../../../utils/route'

export function getUserMenuPersonalSettingsLinkProps(availableSections) {
  const link = `/${ROUTE_PATH_LIST.settings}/${ROUTE_PATH_LIST_SETTINGS.personal}`
  const isAvailable =
    !!availableSections?.[ROUTE_UI_SECTION_NAME.settingsPersonal]

  return {
    reloadDocument: !isAvailable,
    to: isAvailable ? link : getWebappLinkPrefix(link),
  }
}
